module.exports = __webpack_public_path__ + "img/position.cb315b31.png";